import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HelicoptersService } from "../helicopters/helicopters.service";
import { LocalStorageService } from "../shared/local-storage.service";
import { Helicopter } from "../shared/models/helicopter.model";
import { NextDueMaintenanceService } from "../next-due-maintenance/next-due-maintenance.service";

@Component({
    selector: "app-hold-item-list",
    templateUrl: "./hold-item-list.component.html",
    styleUrls: ["./hold-item-list.component.scss"],
    standalone: false,
})
export class HoldItemListComponent implements OnInit {
    public helicoptersArray: Helicopter[] = [];
    public chosenAircraft: Helicopter;

    private _userSession;

    public aircraftOptions: { name: string; value: number }[];
    public selectedAircraftOption: number;

    public helicopterData: any;

    constructor(
        private _route: ActivatedRoute,
        private _helicoptersService: HelicoptersService,
        private _localStorageService: LocalStorageService,
        private _router: Router,
        private _nextDueService: NextDueMaintenanceService,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
    }

    ngOnInit(): void {
        this._helicoptersService.getHelicopters(this._userSession.organizationId).subscribe((helicopters) => {
            this.helicoptersArray = helicopters;
            this.aircraftOptions = this.helicoptersArray.map((h) => {
                return { name: h.registrationMark, value: h.id };
            });
            if (this.helicoptersArray.length > 0) {
                this.selectedAircraftOption = this.helicoptersArray[0].id;
                this.chooseAircraft(this.helicoptersArray[0].id);
            }
        });
    }

    chooseAircraft(helicopterId: number) {
        this._nextDueService.getAircraftData(helicopterId).subscribe((res) => {
            this.chosenAircraft = this.helicoptersArray.find((h) => h.id === helicopterId);
            this.helicopterData = res;
        });
    }
}
